import React, { FC } from 'react';
import classNames from 'classnames/bind';
import styles from './TitleRow.module.scss';
import { ReactComponent as Checkbox } from './img/checkbox.svg';
import { ReactComponent as CheckboxIndeterminate } from './img/checkboxIndeterminate.svg';

const cx = classNames.bind(styles);

interface TitleRowTypes {
  data: string[];
  title: string;
  withCheckbox?: boolean;
  selected?: 'all' | 'some' | 'none';
  toggleSelect?: () => void;
  hidePerformer?: boolean;
  showType?: boolean; 
}

export const TitleRow: FC<TitleRowTypes> = ({
  data,
  title,
  withCheckbox = false,
  selected = 'none',
  toggleSelect,
  hidePerformer = false,
  showType = false,
}) => {
  const classNameInput = cx({
    beneficiaries: title === 'beneficiaries',
    employeds: title === 'employeds',
    orders: title === 'orders',
    employedsCustomer: title === 'employedsCustomer',
    employedsPromo: title === 'employedsPromo',
    ordersCustomer: title === 'ordersCustomer',
    ordersCustomerCheckbox: title === 'ordersCustomerCheckbox',
    ordersWorksupportCheckbox: title === 'ordersWorksupportCheckbox',
    taxesCustomer: title === 'taxesCustomer',
    taxesWorkSupport: title === 'taxesWorkSupport',
    alertsWorkSupport: title === 'alertsWorkSupport',
    usersWorkSupport: title === 'usersWorkSupport',
    performersList: title === 'performersList',
    checks: title === 'checks',
    payments: title === 'payments',
    contracts: title === 'contracts',
    references: title === 'references',
    contractsNoPerformer: title === 'contracts' && hidePerformer,
    withType: title === 'contracts' && showType && !hidePerformer,
  });

  return (
    <div className={classNameInput}>
      {withCheckbox && (
        <div
          className={styles.root_checkbox}
          onClick={(e) => {
            e.preventDefault();
            toggleSelect?.();
          }}>
          {selected === 'all' ? (
            <div className={styles.checkbox_active}>
              <Checkbox />
            </div>
          ) : selected === 'some' ? (
            <div className={styles.checkbox_indeterminate}>
              <CheckboxIndeterminate />
            </div>
          ) : (
            <div className={styles.checkbox}></div>
          )}
        </div>
      )}
      {data.map((elem: string, i: number) => (
        <p
          style={
            elem === 'Баланс' ||
            elem === 'В копилке' ||
            elem === 'Начислено' ||
            elem === 'Сумма, ₽' ||
            elem === 'Стоимость' ||
            elem === 'Холд' ||
            elem === 'Оплачено' ||
            elem === 'Вознаграждение оператора' ||
            elem === 'Лимит, ₽'
              ? { textAlign: 'end' }
              : {}
          }
          key={i}>
          {elem}
        </p>
      ))}
    </div>
  );
};
